import { Theme } from '@emotion/react';
import styled, { Interpolation } from '@emotion/styled';
import { ReactNode } from 'react';

const TertiaryButtonStyled = styled.button`
	color: ${({ theme }) => theme.colors.brand.main};
	padding: 1.2rem;
	min-width: auto;
	background-color: transparent;
	border: none;
	display: flex;
	font-weight: 700;
	cursor: pointer;
	&:hover:not(:disabled) {
		border-color: transparent;
	}
	.icon {
		margin-right: 1.2rem;
		display: inline-block;
		font-size: 133.33%;
		line-height: 1rem;
		i:before {
			vertical-align: middle;
		}
	}
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	icon?: ReactNode;
	children?: ReactNode;
	xStyle?: Interpolation<Theme>;
	disabled?: boolean;
};

export const TertiaryButton = ({ icon, children, xStyle = {}, disabled = false, ...props }: Props) => {
	return (
		<TertiaryButtonStyled disabled={disabled} css={xStyle} {...props}>
			{icon ? <span className="icon">{icon}</span> : null}
			{children}
		</TertiaryButtonStyled>
	);
};
